export default interface IBankUser {
    userID?: number,
    login?: string,
    userName?: string,
    userDescription?: string,
    password: string,
    passwordConfirm?: string,
    serviceCode?: string,
    creationDate?: Date,
    accountEnabled?: boolean,
    enabledFrom?: Date,
    enabledTo?: Date,
    emailAddress?: string,

    isSystem?: boolean,
    isAdministrator?: boolean,
    isManager?: boolean,
    isOperator?: boolean,

    roles: {roleID: number}[],
    groupPolicies: {groupPolicyID: number}[],
    agencies: {agencyCode: string}[],

    //roleItems: IBankRoleItem[]
  }

  export const defaultBankUser: IBankUser = {
    userID: 0,
    login: '',
    userName: '',
    userDescription: '',
    password: 'DEFAULT_PASSWORD',
    passwordConfirm: 'DEFAULT_PASSWORD',
    serviceCode: '',
    creationDate: new Date(),
    accountEnabled: false,
    enabledFrom: new Date(),
    enabledTo: new Date(),
    emailAddress: '',

    isSystem: false,
    isAdministrator: false,
    isManager: false,
    isOperator: false,
    
    roles: Array<{roleID: number}>(0),
    groupPolicies: Array<{groupPolicyID: number}>(0), 
    agencies: Array<{agencyCode: string}>(0),
 }

 export interface IPasswordChange {
   userID: number,
   login: string,

   password: string,
   newPassword: string,
   newPasswordConfirm: string
 }
 export const defaultPasswordChange: IPasswordChange = {
  userID: 0,
  login: '',

  password: '',
  newPassword: '',
  newPasswordConfirm: ''
 }
